import { AbstractControl, UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Injectable } from '@angular/core';

import { UserService } from './user.service';
import { Observable, Subject } from 'rxjs';
import { ProductService } from '../../product/product.service';

export interface ValidationResult {
    [key: string]: boolean;
}

@Injectable()
export class ValidatorService {
    emailTimeout: any;
    codeTimeout: any;
    couponTimeout: any;
    passwordTimeout: any;

    checkingEmail$: Subject<boolean> = new Subject<boolean>();
    checkingCode$: Subject<boolean> = new Subject<boolean>();
    checkingCoupon$: Subject<boolean> = new Subject<boolean>();
    checkingPassword$: Subject<boolean> = new Subject<boolean>();

    constructor(
        private _userService: UserService
        , private _productService: ProductService
    ) {
        // this.checkingEmail$ = new Observable<boolean>(o => this._checkingEmailObserver = o);
        this.checkingEmail$.next(false);
        this.checkingCode$.next(false);
    }

    doPasswordsMatch(passwordKey: string, confirmKey: string) {
        return (group: UntypedFormGroup): { [key: string]: any } => {
            let password = group.controls[passwordKey];
            let confirmPassword = group.controls[confirmKey];

            if (password.value !== confirmPassword.value) {
                return {
                    mismatchedPasswords: true
                };
            }
        }
    }

    //isValidHostingFee(numKey: string) {
    //    return (group: FormGroup): { [key: string]: any } => {
    //        let num = group.controls[numKey];
    //        if (num.value != null && (isNaN(num.value) || num.value < 0)) {
    //            return { invalidEmbeddedHostingFee: true };
    //        }
    //    }
    //}

    //isValidShippingWeight(numKey: string) {
    //    return (group: FormGroup): { [key: string]: any } => {
    //        let num = group.controls[numKey];
    //        if (num.value != null && (isNaN(num.value) || num.value < 0)) {
    //            return { invalidShippingWeight: true };
    //        }
    //    }
    //}

    //isValidPrice(priceKey: string) {
    //    return (group: FormGroup): { [key: string]: any } => {
    //        let price = group.controls[priceKey];
    //        if (price.value == null || (price != null && price.value != null && (isNaN(price.value) || price.value <= 0))) {
    //            return { invalidPrice: true };
    //        }
    //    }
    //}


    //isRangeValid(minKey: string, maxKey: string) {
    //    return (group: FormGroup): { [key: string]: any } => {
    //        let min = group.controls[minKey];
    //        let max = group.controls[maxKey];
    //        if (min.value != null && (isNaN(min.value) || min.value <= 0 || !Number.isInteger(min.value))) {
    //            return { invalidMinimum: true };
    //        }
    //        else if (max.value != null && (isNaN(max.value) || max.value <= 0 || !Number.isInteger(max.value))) {
    //            return { invalidMaximum: true };
    //        }
    //        else if (min.value != null && max.value != null && min.value > max.value) {
    //            return { invalidRange: true };
    //        }
    //    }
    //}

    //isQuantityValid(quantityKey: string) {
    //    return (group: FormGroup): { [key: string]: any } => {
    //        let quantity = group.controls[quantityKey];
    //        if (quantity != null && (isNaN(quantity.value) || quantity.value <= 0 || !Number.isInteger(quantity.value))) {
    //            return { invalidQuantity: true };
    //        }
    //    }
    //}


    //isQuantityValidB(control: FormControl): ValidationResult {
    //    if (isNaN(control.value)) {
    //        return { invalidQuantity: true };
    //    }
    //}

    //isPositiveInteger(control: FormControl): ValidationResult {
    //    if (control != null && (isNaN(control.value) || control.value <= 0 || !Number.isInteger(control.value))) {
    //        return { invalidPositiveInteger: true };
    //    }
    //}

    //isDateValidFormat(control: FormControl): { [key: string]: any } {
    //    //This is hard-coded to use mm/dd/yyyy 
    //    return new Promise((resolve, reject) => {
    //        let unitedStatesDatePattern = /^\d{1,2}\/\d{1,2}\/\d{4}$/;

    //        if (!control.value.match(unitedStatesDatePattern))
    //            resolve({ invalidDateFormat: true });

    //        resolve(null);
    //    });
    //}

    //areDatesAValidRange(dateA: string, dateB: string) {
    //    return (group: FormGroup): { [key: string]: any } => {
    //        let min = group.controls[dateA];
    //        let max = group.controls[dateB];

    //        if (min.value >= max.value) {
    //            return { invalidDateRange: true };
    //        }
    //    }
    //}

    //productRequired(control: FormControl): ValidationResult {
    //    if (control.value.length === 0) {
    //        return { productRequired: true };
    //    }
    //}

    //isUsernameTaken(control: Control): Promise<ValidationResult>  {
    //    return new Promise((resolve, reject) => {
    //        this._userService.usernameTaken(control.value);
    //        this._userService.usernameTaken$
    //            .subscribe(results => {
    //                setTimeout(() => {
    //                    let taken = results;
    //                    if (taken) {
    //                        resolve({ "usernameTaken": taken });
    //                    }
    //                    else {
    //                        resolve(null);
    //                    }
    //                }, 1000);
    //            });
    //    });
    //}

    /**
     * Returns validation error if the control value has an email that is not unique
     */
    isEmailUnique() {
        return (control: AbstractControl): { [key: string]: any } => {
            this.checkingEmail$.next(true);
            const email = control.value;
            clearTimeout(this.emailTimeout);
            return Observable.create(obs => {
                const originalEmail = this._userService.user$.getValue() ? this._userService.user$.getValue().Email : "";
                if (originalEmail && originalEmail == email) {
                    // editing a teacher, teacher should be allowed to select the same email that they started with
                    obs.next(null);
                    obs.complete();
                    this.checkingEmail$.next(false);
                }
                else {
                    this.emailTimeout = setTimeout(() => {
                    this._userService.isEmailUnique(email).subscribe(available => {
                            if (available) {
                                obs.next(null);
                            }
                            else {
                                obs.next({ isEmailUnique: false });
                            }
                            obs.complete();
                            this.checkingEmail$.next(false);
                        })
                    }, 2000);
                }
            });

        };
  }

  /**
   * Returns validation error if the control value has a password that is not valid.
   */
  isPasswordValidAsync() {
    return (control: AbstractControl): { [key: string]: any } => {
      this.checkingPassword$.next(true);
      const password = control.value;
      clearTimeout(this.passwordTimeout);
      return Observable.create(o => {
        this.passwordTimeout = setTimeout(() => {
          this._userService.isPasswordValid(password).subscribe(validation => {
            if (validation.Validated) {
              o.next(null);
            }
            else {
              o.next({ serverMessage: validation.Message });
            }
            o.complete();
            this.checkingPassword$.next(false);
          })
        }, 1000);
      });
    };
  }

  isPromoCodeValid() {
      return (control: AbstractControl): { [key: string]: any } => {
        this.checkingCode$.next(true);
        const code = control.value;
        clearTimeout(this.codeTimeout);
        return Observable.create(o => {
          this.codeTimeout = setTimeout(() => {
            this._userService.isPromoCodeValid(code).subscribe(valid => {
              if (valid) {
                o.next(null);
              }
              else {
                o.next({ isCodeValid: false });
              }
              o.complete();
              this.checkingCode$.next(false);
            })
          }, 2000);
        });
      };
    }

    /**
     * Returns validation error if the coupon code is not valid
     */
    isCodeValid() {
        return (control: AbstractControl): { [key: string]: any } => {
            this.checkingCode$.next(true);
            const code = control.value;
            clearTimeout(this.codeTimeout);
          return Observable.create(obs => {
            const previousCode = this._userService.user$.getValue() ? this._userService.user$.getValue().RedemptionCode : "";
                if ((code == '') || (previousCode && previousCode == code)) {
                    // Code value is empty or didn't change
                    obs.next(null);
                    obs.complete();
                    this.checkingCode$.next(false);
                }
                else {
                    this.codeTimeout = setTimeout(() => {
                        this._userService.isCodeValid(code).subscribe(valid => {
                            if (valid) {
                                obs.next(null);
                            }
                            else {
                                obs.next({ isCodeValid: false });
                            }
                            obs.complete();
                            this.checkingCode$.next(false);
                        })
                    }, 2000);
                }
            });
        };
    }

    /**
     * Returns validation error if the control value has an coupon that is not valid
     */
    isCouponValid() {
        return (control: AbstractControl): { [key: string]: any } => {
            this.checkingCoupon$.next(true);
            const coupon = control.value;
            clearTimeout(this.couponTimeout);
            return Observable.create(o => {
                this.couponTimeout = setTimeout(() => {
                    this._productService.isCouponValid(coupon).subscribe(isValid => {
                        if (isValid) {
                            o.next(null);
                        }
                        else {
                            o.next({ isCouponValid: false });
                        }
                        o.complete();
                        this.checkingCoupon$.next(false);
                    })
                }, 2000);
            });
        };
    }

    //validateMessageCharacterCount(control: FormControl): ValidationResult {
    //    if (control.value != null && control.value.length < 1024) {
    //        return null;
    //    } else {
    //        return { 'exceededMessageCharacterCount': true };
    //    }
    //}

    //validateTitleCharacterCount(control: FormControl): ValidationResult {
    //    if (control.value != null && control.value.length < 100) {
    //        return null;
    //    } else {
    //        return { 'exceededTitleCharacterCount': true };
    //    }
    //}

    validateEmail(control: UntypedFormControl): ValidationResult {
        // RFC 2822 compliant regex
        if (control.value != null && control.value.match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/)) {
            return null;
        }
        else if (control.value == null || control.value == "") {
            return null;
        }
        else {
            return { 'incorrectMailFormat': true };
        }
    }

    validatePassword(control: UntypedFormControl): ValidationResult {
        if (control.value == null || control.value == "") {
            return null;
        } else if (control.value.length >= 6 && control.value.match(/[a-zA-Z]/) && control.value.match(/\d/)) {
            return null;
        }
        else {
            return { 'incorrectPasswordFormat': true };
        }
    }
}
